import { render } from "./SectionParticipants.vue?vue&type=template&id=21ef4252"
import script from "./SectionParticipants.vue?vue&type=script&lang=js"
export * from "./SectionParticipants.vue?vue&type=script&lang=js"

import "./SectionParticipants.vue?vue&type=style&index=0&id=21ef4252&lang=css"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__